module.exports = __webpack_public_path__ + "static/media/photobook-autumn-2026.986dfbef.webp";